<template>
  <div class="container pt-mb-5 pt-3 mb-sm-5 mb-3">
    <div class="dashboard pro-dash">
      <div class="row mt-5">
        <div class="col-lg-3 col-md-4 mb-5">
          <div class="sidebar">
            <a href="#"><h3 class="ser-vis-head dasssh">Dashboard</h3></a>
            <ul>
              <li class="prof-1">
                <a href="" class="profile-side hover-color">
                  <img :src="image1" class="iamgdd1" />
                  User Profile</a
                >
              </li>
              <li>
                <a :href="petData" class="hover-color"><img :src="image2" class="iamgdd1" />My Pets</a>
              </li>
              <li>
                <a :href="myBookings" class="hover-color"><img :src="image3" class="iamgdd1" />My Bookings</a>
              </li>
              <li>
                <a :href="myReward" class="hover-color"> <img :src="image3" class="iamgdd1" />My Rewards</a>
              </li>
              <li>
                <a :href="logoutRoute" class="hover-color"><img :src="image4" class="iamgdd1" />Logout</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-9 col-md-8 mb-5">
          <h1 class="fw-700 ed-pro-head mb-4">Edit Profile</h1>
          <div class="main-content">
            <form @submit.prevent="submitForm" class="profile-form">
              <div class="">
                <div class="">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-lg-6 mb-3">
                          <div class="pro-man">
                            <img :src="imageToShow" />
                            <div>
                              <input type="file" class="ms-3" name="myImage" @change="handleFileUpload" />
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6 mb-3">
                          <div class="form-group">
                            <label class="mb-2">Name</label>
                            <input type="text" name="name" class="form-control rounded-0 sel-control" placeholder="Enter Your Name" v-model="userData.first_name" required />
                          </div>
                        </div>
                        <div class="col-md-6 mb-3">
                          <div class="form-group">
                            <label class="mb-2">Email Address</label>
                            <input type="email" name="email" class="form-control rounded-0 sel-control" placeholder="Enter Your Email Address" v-model="userData.email" required />
                          </div>
                        </div>
                        <div class="col-md-6 mb-3">
                          <div class="form-group">
                            <label class="mb-2">Phone Number</label>
                            <input type="number" name="mobile" pattern="[0-9]*" class="form-control rounded-0 sel-control" placeholder="Enter Your Phone Number" v-model="userData.mobile" required />
                          </div>
                        </div>
                        <div class="col-md-6 mb-3">
                          <div class="form-group">
                            <label class="mb-2">Password</label>
                            <input type="password" name="password" class="form-control rounded-0 sel-control" placeholder="Enter Your Password" v-model="password" />
                          </div>
                        </div>
                        <div class="col-md-6 mb-3">
                          <div class="form-group">
                            <label class="mb-2">Address</label>
                            <textarea type="text" name="address" class="form-control rounded-0 sel-control" placeholder="Enter Your Address" v-model="userData.address"></textarea>
                          </div>
                        </div>
                        <!-- <div class="col-md-6 mb-3">
                          <div class="form-group">
                            <label class="mb-2">Confirm Password</label>
                            <input type="password" name="password" class="form-control rounded-0 sel-control" placeholder="Enter Your Confirm Password"/>
                          </div>
                        </div> -->
                        <div class="col-lg-12">
                          <div class="profile-btn mt-3">
                            <input type="submit" class="btn btn-primary fw-600 rounded-0 reg-btn s-btn" value="Submit" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="spring-img">
    <img :src="image2" />
  </div>

  <div class="spring-img-2">
    <img :src="image3" />
  </div> -->
</template>

  <script setup>
import { ref, computed } from 'vue'
import axios from 'axios'

const { bookingsData, petData, logoutRoute, userData, updateRoute, myBookings, image1, image2, image3, image4, image5, myReward } = defineProps(['bookingsData', 'petData', 'logoutRoute', 'userData', 'updateRoute', 'myBookings', 'image1', 'image2', 'image3', 'image4', 'image5', 'myReward'])

const userDataRef = ref(userData)
const password = ref(null)
const address = ref(null)
const profileImg = ref(userData.avatar)
const previewImage = ref(null)
const handleFileUpload = (event) => {
  const file = event.target.files[0]
  const reader = new FileReader()

  reader.onload = () => {
    previewImage.value = reader.result
  }
  profileImg.value = file
  reader.readAsDataURL(file)
  return file
}
const imageToShow = computed(() => {
  return previewImage.value || userData.avatar
})

console.log('imageToShow', imageToShow)
const isValidPhoneNumber = (password) => {
  const phoneNumberRegex = /^\d{4}$/;
  return phoneNumberRegex.test(password);
}
const submitForm = async () => {
  console.log("phone",password)
  if (!isValidPhoneNumber(password.value)) {
    window.errorSnackbar('Password must be 4 digits');
    return;
  }
  const formData = new FormData()

  formData.append('profileImage', profileImg.value)
  userDataRef.value.password = password.value
  // userDataRef.value.address = address.value
  formData.append('userData', JSON.stringify(userDataRef.value))
  const updateResponse = await axios.post(`${updateRoute}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  console.log('updateResponse', updateResponse.data.message)
  window.successSnackbar(updateResponse.data.message)
}
</script>

  <style scoped>
/* .dashboard {
    display: flex;
    margin: 0 auto;
  } */

.sidebar {
  max-width: 100%;
  padding: 20px;
  top: 48px;
  border-radius: 10px;
  position: static;
  box-shadow: none !important;
  background: #f8f8f8;
}

.sidebar h2 {
  margin-bottom: 20px;
}

.sidebar ul {
  list-style: none;
  padding: 0;
}

.sidebar ul li {
  margin-bottom: 10px;
  padding: 10px 15px;
}

.sidebar ul li a {
  text-decoration: none;
  color: #2e2928;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}

/* .sidebar ul li a:hover {
  color: #bf360c;
} */

.main-content {
  flex: 1;
  padding: 20px;
  margin-left: 0px !important;
  background-color: white;
  border-radius: 10px;
  /* margin-top: 40px; */
  /* box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; */
  margin-bottom: 20px;
  border: 1px solid #ececec;
}

.stats {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.stat-card {
  flex: 1;
  padding: 10px;
  background-color: #f0f0f0;
  border-radius: 5px;
  text-align: center;
}

.order-list {
  list-style: none;
  padding: 0;
}

.order-list li {
  margin-bottom: 5px;
  border: 1px solid #ddd;
  padding: 5px;
  display: flex;
  justify-content: space-between;
}
.clos-btn {
  color: #000;
  background-color: #ffff !important;
  border-radius: 10px;
}

.add-new-btns {
  color: black;
  background: transparent;
}
.add-new-btns:hover {
  color: white;
  background-color: #bf360c;
}

.profile-side {
  color: #bf360c !important;
}

.my_booking_head {
  font-size: 20px;
  font-weight: 600;
  color: #bf360c;
  margin-bottom: 20px;
}

/* .profile-form {
  display: flex;
  justify-content: center;
} */

.ed-pro-head {
  font-size: 20px;
  font-weight: 600;
  color: #2e2928;
}

.pro-man img {
  height: 90px;
  width: 90px;
  border-radius: 15px;
  object-fit: cover;
}

.pro-man {
  display: flex;
  align-items: center;
  /* justify-content: center; */
}

.s-btn {
  width: max-content;
}

.spring-img img {
  width: 150px;
}

.web-bg {
  position: relative;
}

/* .pro-dash {
  margin-bottom: 70px;
} */

/* .spring-img {
  position: absolute;
  bottom: 20px;
  left: -21%;
} */

.web-bg {
  position: relative;
}

.spring-img {
  position: absolute;
  bottom: 10%;
  left: -40px;
}

.spring-img-2 img {
  width: 130px;
}

.spring-img-2 {
  position: absolute;
  top: 30px;
  right: 0;
}

.profile-form label {
  color: #2e2928;
  font-weight: 500;
}

.dasssh {
  margin-bottom: 25px !important;
}

.iamgdd2 {
  display: none;
  width: 15px;
}

.iamgdd1 {
  width: 30px;
  margin-right: 10px;
}

.sidebar ul li:hover {
  background-color: #f9ede8;
  border-radius: 20px;
}

.prof-1 {
  background-color: #f9ede8 !important;
  border-radius: 20px;
  margin-bottom: 10px;
}

.sidebar ul li:hover .hover-color {
  color: #bf360c !important;
  /* color: red !important; */
}

/* .sidebar ul li:hover .iamgdd2 {
  display: block !important;
} */

/* .sidebar ul li:hover .iamgdd1 {
  display: none !important;
} */

/* media css */

@media screen and (max-width: 1199px) {
  /* .sidebar {
    height: 250px;
  } */
}

@media screen and (max-width: 991px) {
  .table_resposive {
    display: block;
    width: 100%;
    overflow-x: auto;
  }
}

@media screen and (max-width: 767px) {
  .web-bg .sidebar {
    height: auto !important;
  }
  .web-bg .main-content {
    margin-top: 20px;
  }
}

@media screen and (max-width: 1600px) {
  .spring-img-2 img {
    display: none;
  }
  .spring-img img {
    display: none;
  }
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type='number'] {
  -moz-appearance: textfield;
}
</style>
